import { useState, useEffect, useCallback } from "react";
import { fetchRoleStagePermissionMatrix } from "../api/fetchRoleStagePermissionMatrix";
import {
  MatrixPermission,
  MatrixRole,
  MatrixStage,
} from "../api/fetchRoleStagePermissionMatrix/types";

export function useRoleStagePermissionMatrix() {
  const [stages, setStages] = useState<MatrixStage[]>([]);
  const [permissions, setPermissions] = useState<MatrixPermission[]>([]);
  const [roles, setRoles] = useState<MatrixRole[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadMatrix = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchRoleStagePermissionMatrix();
      setStages(response.stages);
      setPermissions(response.permissions);
      setRoles(response.roles);
    } catch (err) {
      setError(
        err instanceof Error ? err.message : "Failed to load business roles",
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMatrix();
  }, [loadMatrix]);

  return {
    stages,
    permissions,
    roles,
    loading,
    error,
    refetch: loadMatrix,
  };
}
